import { keccakAsU8a } from '@polkadot/util-crypto';
const definitions = {
    hasher: keccakAsU8a
};
export default definitions;
